import { FormControl } from '@fiverr-private/forms';

export default FormControl;
